<template>

  <div class="text-center flex current-call-wrapper">
    <el-card class="connected-call card-base card-shadow--medium" :class="type">
      <div slot="header" class="clearfix">
        <div class="avatar-group">
          <div class="contact-avatar">
            <v-svg sprite="call-inbound" v-if="direction === 'recipient'"/>
            <v-svg sprite="call-outbound" class="voxo-blue" v-if="direction === 'initiator'"/>
          </div>
          <div class="caller-id">
            <div v-if="conferencing">
              <div class="text-left">
                <strong>{{ swapActive && atxferActive ? 'Transfer/Merge' : 'Conference'}}</strong>
              </div>
              <div class="text-muted caller-id-number">
                {{swapActive && atxferActive ? numberFormatter(atxferCallerId) : participants.length + 'Participants'}}
              </div>
            </div>
            <div v-else>
              <div class="text-left">
                <strong>{{ swapActive && atxferActive ? 'Transfer/Merge' : callerName}}</strong>
              </div>
              <div class="text-muted caller-id-number">
                {{ swapActive && atxferActive ? numberFormatter(atxferCallerId) : `${numberFormatter(cidnum)}${dtmfData}`}}
              </div>
            </div>
          </div>
          <span class="call-badge">
            <el-tooltip effect="dark" content="Inbound" placement="right" v-if="direction === 'recipient'">
              <el-badge :value="convertTime(durationCount)" class="item" type="success"></el-badge>
            </el-tooltip>
            <el-tooltip effect="dark" content="Outbound" placement="right" v-if="direction === 'initiator'">
              <el-badge :value="convertTime(durationCount)" class="item" type="primary"></el-badge>
            </el-tooltip>
          </span>
        </div>
      </div>
      <div class="call-connection-info">
        <div v-if="!attendedActive">
          <el-tooltip effect="dark" content="Hangup" placement="bottom">
            <el-button
              class="table-action-button icon-red mr-5"
              @click="callHangup(callItem)"
            >
              <v-svg sprite="phone-down"></v-svg>
            </el-button>
          </el-tooltip>
          <div class="flex justify-flex-end full-width">
          </div>
        </div>
        <div v-else class="flex justify-flex-end full-width">
          <el-tooltip placement="bottom" content="Cancel Transfer">
            <el-button
              class="call-button table-action-button icon-red"
              @click="cancelAtxfer(callItem)"
              style="margin-left: 0px;">
              <v-svg sprite="exit"></v-svg>
            </el-button>
          </el-tooltip>
          <el-tooltip placement="bottom" content="Hang Up / Complete Transfer">
            <el-button
              class="call-button table-action-button icon-blue"
              @click="completeAtxfer(callItem)"
              style="margin-left: 10px;">
              <v-svg sprite="call-forward"></v-svg>
            </el-button>
          </el-tooltip>
          <el-tooltip placement="bottom" content="Swap">
            <el-button
              class="call-button table-action-button icon-green"
              @click="swapAtxfer">
              <v-svg sprite="call-flip"></v-svg>
            </el-button>
          </el-tooltip>
          <el-tooltip placement="bottom" content="Merge">
            <el-button
              class="call-button table-action-button"
              @click="mergeAtxfer">
              <v-svg sprite="merge-2"></v-svg>
            </el-button>
          </el-tooltip>
        </div>
        <div class="flex justify-flex-end full-width">
          <el-tooltip v-if="!attendedActive && softphoneCall" effect="dark" content="Move to another device" placement="bottom">
            <el-button
              class="call-button table-action-button icon-green"
              @click="quickTransfer()">
              <v-svg sprite="devices"></v-svg>
            </el-button>
          </el-tooltip>
          <el-tooltip v-if="!attendedActive" effect="dark" content="Transfer / Conference" placement="bottom">
            <el-button
              class="call-button table-action-button icon-blue"
              @click="requestTransfer(callItem)"
              :disabled="callItem.disabledButtons"
            >
              <v-svg sprite="transfer"></v-svg>
            </el-button>
          </el-tooltip>
          <el-tooltip effect="dark" :content="muted ? 'Unmute' : 'Mute'" placement="bottom" v-if="softphoneCall && callItem.buttonsReady">
            <el-button
              class="call-button table-action-button icon-yellow"
              @click="callMute"
            >
              <v-svg v-if="muted" sprite="microphone-mute"></v-svg>
              <v-svg v-else sprite="microphone"></v-svg>
            </el-button>
          </el-tooltip>
          <div v-if="!attendedActive">
            <el-tooltip effect="dark" :content="callOnHold ? 'Resume' : 'Hold'" placement="bottom" v-if="softphoneCall && !callOnHold && callItem.buttonsReady">
              <el-button
                class="call-button table-action-button icon-orange"
                @click="callHold"
              >
                <v-svg style="margin-top: 2px;" sprite="call-pause" class="voxo-white"></v-svg>
              </el-button>
            </el-tooltip>
            <el-tooltip effect="dark" :content="callOnHold ? 'Resume' : 'Hold'" placement="bottom" v-if="softphoneCall && callOnHold && callItem.buttonsReady">
              <el-button
                class="call-button table-action-button icon-green"
                @click="callHold"
              >
                <v-svg style="margin-top: 2px; margin-left: 2px;" sprite="play" class="voxo-white"></v-svg>
              </el-button>
            </el-tooltip>
          </div>
          <mini-keypad
            style="margin-left: 5px;"
            placement="right"
            :channel="channel"
            :callItem="callItem"
            :disabled="callItem.disabledButtons"
            :server="systemname"
            @sendDTMF="sendDTFM"
            :sipHandle="sipHandle"
          />
        </div>
      </div>
      <el-popover
        v-if="conferencing"
        width="350"
        class="conference-participants"
        placement="left">
        <el-table
          :data="participants"
          height="200px">
          <el-table-column
            prop="name"
            label="Name"
            sortable>
          </el-table-column>
          <el-table-column
            prop="number"
            label="Number"
            :formatter="listNumberFormatter"
            sortable>
          </el-table-column>
        </el-table>
        <div slot="reference">
          <div class="participants-icon">
            <el-icon class="el-icon-arrow-right voxo-white"></el-icon>
          </div>
        </div>
      </el-popover>
    </el-card>

    <el-card class="command-center ml-10 text-left flex justify-center align-flex-end" v-if="type === 'salesforce'">
      <div>
        <el-tooltip content="Search contact" placement="top">
          <el-button
            @click="searchContact"
            class="table-action-button"
          >
            <v-svg class="voxo-green" sprite="user" />
          </el-button>
        </el-tooltip>
        <el-tooltip content="Search account" placement="top">
          <el-button
            @click="searchAccount"
            class="table-action-button ml-0"
          >
            <v-svg class="voxo-blue" sprite="lighthouse" />
          </el-button>
        </el-tooltip>
        <div class="mt-5">
          <el-tooltip content="Search lead" placement="bottom">
            <el-button
              @click="searchLead"
              class="table-action-button"
            >
              <v-svg class="voxo-purple" sprite="megaphone" />
            </el-button>
          </el-tooltip>
          <el-tooltip content="Follow flow" placement="bottom">
            <el-button
              @click="followFlow"
              class="table-action-button"
            >
              <v-svg class="voxo-pink" sprite="list" />
            </el-button>
          </el-tooltip>
        </div>
      </div>
    </el-card>
  </div>

</template>

<script>

import miniKeypad from '@/views/hudportal/softphone/components/mini-keypad';
import feathersClient from "@/feathers/feathers-client";
import { mapGetters, mapActions } from 'vuex';
import {globalEventBus} from "@/globalEventBus";
import {dtmfKeyMap} from '@/ref/hotkey-mapping';
import {phoneNumberFormatter} from "@/globals/globals";

export default {
  name: 'ConnectedCall',
  props: {
    channel: {required: true},
    systemname: {required:true},
    cidnum: {required: true},
    cidname: {required: true},
    direction: {required: true},
    callItem: {required: true},
    duration: {required: true},
    softphoneCall: {required: true, default: false},
    sipHandle: {required: true},
    onHold: {required: true},
    atxferActive: {default: false},
    atxferCallerId: {default: null},
    conferencing: {default: false},
    participants: {default: () => []},
    confBridgeId: {default: ''},
    dtmfNums: {required: true},
    type: {required: true}
  },
  data () {
    return {
      durationCounter: null,
      conferencePolling: null,
      durationCount: this.duration,
      callOnHold: false,
      muted: false,
      attendedActive: false,
      confChannel: null,
      eventChannels: [],
      swapActive: false,
      modKeyActive: false,
      callerName: '',
      dtmfData: ''
    }
  },
  components: { miniKeypad },
  computed: {
    ...mapGetters('mycurrentcalls', {myCallList: 'find'}),
    ...mapGetters('phonebook-entries', {loadPersonalDirectory: 'find'}),
    softphoneEnabled(){
      return this.$store.state.softphoneEnabled;
    },
    userHostServer(){
      return this.$store.state.userHostServer;
    },
    user(){
      return this.$store.state.auth.user;
    },
  },
  watch: {
    onHold(){
      this.callOnHold = this.onHold;
    },
    atxferActive(){
      this.attendedActive = this.atxferActive;
      if(this.atxferActive){
        this.callOnHold = false;
        this.swapActive = true;
      }
    },
    conferencing(){
      if(this.conferencing){
        this.joinConfSocketChannel();
        this.registerConfEvents();
      }
    },
    softphoneEnabled(){
      if(this.softphoneEnabled){
        this.registerKeyEvents()
      }
    },
    cidnum(){
      this.findCallerName();
    },
    dtmfNums(){
      this.dtmfData = this.dtmfNums.length ? `,${this.dtmfNums.join(',')}` : '';
    }
  },
  methods: {
    async findCallerName(){
      let callerName = this.cidname;

      const bizContact = await feathersClient.service('extensions').find({
        query: {
          tenantId: this.user.myExtension.tenantId,
          number: this.cidnum
        }
      });

      if(bizContact.length){
        callerName = bizContact[0].name;
      } else{
        const personalContact = this.loadPersonalDirectory({
          query: {
            "PHONE1": this.cidnum
          }
        }).data;
        if(personalContact.length){
          callerName = personalContact[0].NAME;
        }
      }
      this.callerName = callerName.length ? callerName : 'Unknown';
    },
    requestTransfer(item) {
      globalEventBus.$emit('salesforceTransferRequest', item);
    },
    callHangup(item){

      this.softphoneCall
        ? globalEventBus.$emit('softphoneConnectedCallHangup', this.sipHandle)
        : feathersClient.service('nats-actions-handler').create({
          reqType: 'hangup',
          channel: item.channel,
          server: item.systemname
        });

      const ringbackAudio = document.getElementById('outbound-call-ringing').querySelector('audio');
      ringbackAudio.pause();
      ringbackAudio.currentTime = 0;

      const endAudio = document.getElementById('call-ended').querySelector('audio');
      endAudio.play();
    },
    quickTransfer() {
      if (this.sipHandle) {
        const sipHandle = {...this.sipHandle};
        const quickTransferActive = true;
        const callItem = {channel: this.channel, systemname: this.systemname};
        globalEventBus.$emit('softphoneProcessTransfer', {sipHandle, destination: this.user.myExtension.number, quickTransferActive, callItem});
      }
    },
    callHold(){
      if(this.callOnHold){

        //the call is being resume. we need to take care of holding the others
        globalEventBus.$emit('softphoneCallUnhold', this.sipHandle);
        const calls = this.myCallList().data;
        if(calls.length){
          for(let i = 0; i < calls.length; i++){
            const {channel, cidnum, softphoneCall} = calls[i];
            if(cidnum === this.cidnum){
              this.$store.commit('mycurrentcalls/updateItem', {channel, onHold: false});
            } else{
              if(softphoneCall){
                this.$store.commit('mycurrentcalls/updateItem', {channel, onHold: true});
              }
            }
          }
        }
        this.callOnHold = false;
      } else{
        globalEventBus.$emit('softphoneCallHold', this.sipHandle);
        this.callOnHold = true;
      }
    },
    numberFormatter(number) {
      return phoneNumberFormatter(number);
    },
    listNumberFormatter(row, column, value) {
      return phoneNumberFormatter(value);
    },
    updateDuration(){
      this.durationCount++;
    },
    convertTime(time) {
      if(time < 60) {return time + 's'}
      const hours = Math.floor(time / 3600);
      const remainderSeconds = time % 3600;
      const minutes = Math.floor(remainderSeconds / 60);
      const seconds = Math.round(remainderSeconds % 60);
      if (hours > 0) {return hours + 'hr ' + minutes + 'm';}
      if (minutes > 0) {return minutes + 'm ' + seconds + 's';}
      return 0;
    },
    callMute(){
      if(this.muted){
        globalEventBus.$emit('softphoneUnmute', this.sipHandle);
        this.muted = false;
      } else{
        globalEventBus.$emit('softphoneMute', this.sipHandle);
        this.muted = true;
      }
    },
    cancelAtxfer(item){
      const {softphoneCall, channel, systemname} = this;
      this.$store.commit('mycurrentcalls/updateItem', {channel, atxferActive: false, atxferCallerId: null});

      //do this for a desk phone call
      if(!softphoneCall){
        feathersClient.service('nats-actions-handler').create({
          reqType: 'cancelAtxfer',
          channel,
          server: systemname
        });
        return;
      }

      //do this for a softphone session
      const callItem = {channel, systemname};
      globalEventBus.$emit('softphoneCancelAtxfer', {...this.sipHandle, callItem})
    },
    completeAtxfer(item){
      this.$store.commit('mycurrentcalls/updateItem', {channel: this.channel, atxferActive: false, atxferCallerId: null});
      this.callHangup(item);
    },
    swapAtxfer(){
      this.swapActive = !this.swapActive;

      //do this for a desk phone session
      if(!this.softphoneCall){
        feathersClient.service('nats-actions-handler').create({
          reqType: 'swapAtxfer',
          channel: this.channel,
          server: this.userHostServer,
        });
        return;
      }

      //do this for a softphone session
      const callItem = {channel: this.channel, systemname: this.systemname};
      globalEventBus.$emit('softphoneSwapAtxfer', {...this.sipHandle, callItem});
    },
    mergeAtxfer(){
      const {channel, userHostServer, softphoneCall, systemname} = this;
      this.$store.commit('mycurrentcalls/updateItem', {channel: this.channel, atxferActive: false, atxferCallerId: null});

      //do this for a desk phone
      if(!softphoneCall){
        feathersClient.service('nats-actions-handler').create({
          reqType: 'mergeAtxfer',
          channel,
          server: userHostServer
        });
        return;
      }

      //do this for a softphone session
      const callItem = {channel, systemname};
      globalEventBus.$emit('softphoneMergeAtxfer', {...this.sipHandle, callItem});
    },
    async joinConfSocketChannel(){
      const channelMemberships = feathersClient.service('channel-memberships');
      const confChannel = {
        roomType: 'conferences',
        bridgeId: this.confBridgeId,
        server: this.userHostServer
      };

      await channelMemberships.remove(null, {query: {channelName: this.confChannel}}).then(res => console.log(res));

      channelMemberships.create(confChannel).then(res => {
        this.confChannel = `conferences/${confChannel.server}/${confChannel.bridgeId}`;
      });
    },
    pushChannel(evt){
      if(evt.socketChannel === this.confChannel){
        this.eventChannels.push(evt);
      }
    },
    updateConference(evt){
      if(evt.socketChannel === this.confChannel){
        const activeChannels = [...this.eventChannels];
        let numbers = [this.user.myExtension.number];
        for(let i = 0; i < activeChannels.length; i++){
          numbers.push(activeChannels[i].number);
        }

        let newList = [];
        const currentList = [...this.participants]
        for(let i = 0; i < currentList.length; i++){
          if(numbers.includes(currentList[i].number)){
            newList.push(currentList[i]);
          }
        }

        this.$store.commit('mycurrentcalls/updateItem', {
          channel: this.channel,
          participants: null,
        });
        this.$store.commit('mycurrentcalls/updateItem', {
          channel: this.channel,
          participants: newList,
        });
        this.eventChannels = [];
      }
    },
    registerConfEvents(){
      globalEventBus.$on('conferenceChannel', this.pushChannel);
      globalEventBus.$on('conferenceInfoComplete', this.updateConference);
    },
    processReconnect(){
      if(this.conferencing){
        this.joinConfSocketChannel();
      }
    },
    handleHotKeys(e){
      if(e.key === 'Alt'){
        e.preventDefault();
        this.modKeyActive = true
      }
      if(this.softphoneEnabled){
        if(this.modKeyActive && !this.callOnHold){
          if(dtmfKeyMap.hasOwnProperty(e.code)){
            e.preventDefault();
            this.sendDTFM(dtmfKeyMap[e.code]);
            return;
          }
          if(e.code === 'KeyM'){
            e.preventDefault();
            this.callMute();
            return;
          }
          if(e.code === 'KeyH'){
            e.preventDefault();
            this.callHold();
            return;
          }
          if(e.code === 'KeyT'){
            e.preventDefault();
            this.requestTransfer(this.callItem);
            return
          }
          if(e.code === 'KeyB'){
            e.preventDefault();
            this.callHangup(this.callItem);
          }
        }
      }
    },
    disableKeyMod(e){
      if(e.key === 'Alt'){
        this.modKeyActive = false;
      }
    },
    registerKeyEvents(){
      window.addEventListener('keydown', this.handleHotKeys);
      window.addEventListener('keyup', this.disableKeyMod);
    },
    sendDTFM(val){

      const {sipHandle, softphoneCall, channel, systemname} = this;

      //do this for a desk phone call
      if(!softphoneCall){
        feathersClient.service('nats-actions-handler').create({
          reqType: 'DTMF',
          value: val,
          channel,
          hostServer: systemname
        });
        return;
      }

      //do this for a softphone session
      const callItem = {channel, systemname};
      globalEventBus.$emit('softphoneSendDTMF', {sipHandle, value: val, callItem});
    },
    pollConferenceInfo() {
      if(this.conferencing){
        console.log('we are polling to update conf info');
        //make nats action handler request to poll conference. this will fire events to update the conf
        feathersClient.service('nats-actions-handler').create({
          reqType: 'confPoll',
          channel: this.confChannel
        });
      }
    },
    searchContact() {
      globalEventBus.$emit('entitySearchAndScreenPop', {cidnum: this.cidnum, direction: this.direction, type: 'Contact'});
    },
    searchAccount() {
      globalEventBus.$emit('entitySearchAndScreenPop', {cidnum: this.cidnum, direction: this.direction, type: 'Account'});
    },
    searchLead() {
      globalEventBus.$emit('entitySearchAndScreenPop', {cidnum: this.cidnum, direction: this.direction, type: 'Lead'});
    },
    followFlow() {
      globalEventBus.$emit('searchAndScreenPop', {cidnum: this.cidnum, direction : this.direction});
    }
  },
  mounted(){
    this.durationCounter = setInterval(this.updateDuration, 1000);
    this.conferencePolling = setInterval(this.pollConferenceInfo, 10000);
    globalEventBus.$on('appReconnected', this.processReconnect);
    this.registerKeyEvents();
    this.findCallerName();
  },
  beforeDestroy() {
    const channelMemberships = feathersClient.service('channel-memberships');
    clearInterval(this.durationCounter);
    clearInterval(this.conferencePolling);
    if(this.confChannel){
      channelMemberships.remove(null, {query: {channelName: this.confChannel}}).then(res => console.log(res));
    }
    globalEventBus.$off('conferenceChannel', this.pushChannel);
    globalEventBus.$off('conferenceInfoComplete', this.updateConference);
    globalEventBus.$off('appReconnected', this.processReconnect);
    window.removeEventListener('keydown', this.handleHotKeys);
    window.removeEventListener('keyup', this.disableKeyMod);
  }
}

</script>

<style lang="scss" scoped>

@import '../../../../../assets/scss/variables';

.nav-call-button{
  background-color: $voxo-aqua;
}

.caller-id-number {
  font-size: 11px;
  text-align: left;
}

.connected-call.salesforce{
  width: 303px;
}

.connected-call.hubspot{
  width: 100%;
}

.command-center{
  //width: 100px;
  .el-button + .el-button {
    margin-left: 5px;
  }
}

@keyframes border-pulsate {
  0%   { border-color: $voxo-green; }
  50%  { border-color: transparent; }
  100% { border-color: $voxo-green; }
}

.border-ringing{
  border-width: 2px;
  border-style: solid;
  border-color: $voxo-green;
  //animation: border-pulsate 2s infinite;
  //will-change: transform;
}

button.call-button{
  margin-left: 5px;
}

.atxfer-popover {
  min-width: 70px;
}

.conference-participants{
  position: absolute;
  right: 0;
  top: 38px;
}

.participants-icon{
  cursor: pointer;
  padding: 1px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: $voxo-blue;
  width: 12px;
  height: 12px;
  border-radius: 50%;
}

.el-icon-arrow-right:before{
  font-size: 11px;
  position: relative;
  top: -1px;
  margin-left: 1px;
}

.full-width {
  width: 100%;
}

</style>
